import React from 'react';

/**
 * HOC that wraps TopBarFileMenu to inject backendSpecs actions and selectors
 */
const TopBarFileMenuWrapper = (Original, system) => {
  const Wrapper = (props) => {
    const { backendSpecsActions, backendSpecsSelectors } = system;

    return (
      <Original
        {...props}
        backendSpecsActions={backendSpecsActions}
        backendSpecsSelectors={backendSpecsSelectors}
      />
    );
  };

  return Wrapper;
};

export default TopBarFileMenuWrapper;
